import React from 'react';

const Hero = ({ onCreateClick }) => {
  return (
    <section 
      id="home" 
      className="relative min-h-[600px] md:min-h-[700px] overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('/hero-background.png')`,
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-white/30"></div>

      <div className="container mx-auto px-6 relative z-10 py-20 md:py-32">
        <div className="max-w-4xl">
          <div className="inline-block">
            <h1 className="text-4xl sm:text-5xl md:text-5xl font-black mb-3 leading-tight text-gray-900" style={{ fontFamily: "'Diplomata', 'Arbutus', cursive" }}>
              Curate | Captivate | Connect
            </h1>
            <div className="w-full h-1.5 bg-orange-500 mb-8"></div>
          </div>

          <p className="text-xl md:text-2xl text-gray-900 mb-4 leading-relaxed" style={{ fontFamily: "'Quintessential', cursive" }}>
            From Visualizing, Creative Designing, Event Strategy till Event Execution,<br />
            we get our hands in everything!
          </p>

          <p className="text-xl md:text-2xl text-gray-900 mb-8" style={{ fontFamily: "'Quintessential', cursive" }}>
            We just like our work perfectly done!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;